import React from "react"
import { Link, graphql } from "gatsby"

import Layout from "../components/Layout"
import SEO from "../components/seo"

class ProjectPageTemplate extends React.Component {
  render() {
    const project = this.props.data.markdownRemark
    const siteTitle = this.props.data.site.siteMetadata.title

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO title={project.frontmatter.title} description={project.excerpt} />
        <div style={{ display: "flex", alignItems: "baseline" }}>
          <h1 style={{ margin: 0 }}>{project.frontmatter.title}</h1>
        </div>
        <div>
          <a href={project.frontmatter.url} target="_blank">
            {project.frontmatter.url}
          </a>
        </div>
        <div>
          <a href={project.frontmatter.github} target="_blank">
            {project.frontmatter.github}
          </a>
        </div>
        <div>{project.frontmatter.status}</div>
        <div>{(project.frontmatter.tags || []).join(", ")}</div>

        <div dangerouslySetInnerHTML={{ __html: project.html }} />
      </Layout>
    )
  }
}

export default ProjectPageTemplate

export const pageQuery = graphql`
  query ProjectBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        tags
        status
        url
        github
      }
    }
  }
`
